import {Injectable} from '@angular/core';
import {AssetFilter} from "./asset-filter";
import {BehaviorSubject, ReplaySubject, Subject} from "rxjs";
import {AssetView} from "./asset-view";
import {AssetService} from "./asset.service";
import {ServerFilter} from '../dam-header/filter-bar/server-filter';
import {OrderBy} from './order-by';
import {OrderDirection} from './order-direction';
import {AssetAction} from '../dam-header/action-bar/asset-action';
import {AssetCount} from './asset-count';
import {Asset} from './asset.model';
import {Collection, ReadonlyCollection} from "../collection/collection.model";
import {PageInfo} from './page-info';

@Injectable({
    providedIn: 'root'
})
export class AssetStateService {

    loadedAssets$ = new BehaviorSubject<Asset[]>([]);
    filter$ = new BehaviorSubject<AssetFilter>(this.createDefaultAssetFilter());
    serverFilter$ = new BehaviorSubject<ServerFilter[]>([]);
    result$ = new BehaviorSubject<AssetView | null>(null);
    assetCount$ = new BehaviorSubject<AssetCount>(this.createInitialAssetCount());
    assetAction$ = new Subject<AssetAction>();
    filterBlocked$ = new BehaviorSubject<boolean>(true);
    assetToView$ = new ReplaySubject<Asset>(1)
    assetSelection$ = new BehaviorSubject<Asset[]>([]);
    collection$ = new BehaviorSubject<Collection | null>(null);
    readonlyCollection$ = new BehaviorSubject<ReadonlyCollection | null>(null);
    pageInfo$ = new BehaviorSubject<PageInfo | null>(null);
    assetUuidFromQueryParam$: Subject<string | null> = new Subject();
    pdfSource$: Subject<string | null> = new Subject();

    constructor(
        private assetService: AssetService
    ) {
        // this.createDefaultAssetFilter();
    }


    set assetAction(action:AssetAction) {
        this.assetAction$.next(action);
    }
    set assetUuidFromQueryParam(to: string | null) {
        this.assetUuidFromQueryParam$.next(to);
    }
    set pdfSource(source:string | null) {
        this.pdfSource$.next(source);
    }
    set assetCount(assetCount:AssetCount) {
        this.assetCount$.next(assetCount);
    }
    set AssetToView(asset:Asset) {
        this.assetToView$.next(asset);
    }
    set pageInfo(pageInfo:PageInfo) {
        this.pageInfo$.next(pageInfo);
    }

    get loadedAssets() {
        return this.loadedAssets$.value;
    }

    clearLoadedAssets() {
        this.loadedAssets$.next([]);
    }

    get filter() {
        return this.filter$.value;
    }

    set filter(filter: AssetFilter) {
        this.filterBlocked = true;
        this.filter$.next(filter);
        if (filter.page === 1){
            this.clearLoadedAssets();
        }
        this.assetService.getAssets(filter).subscribe(
            result => {
               /* const assView: AssetView = {
                    assets: result.data,
                   //  pageInfo: result.pageInfo
                }
                this.result$.next(assView)*/
               /* if (result.pageInfo.currentPage === 1) {
                    this.clearLoadedAssets();
                }*/
                this.loadedAssets$.next([...this.loadedAssets, ...result.data]);
            }
        );
        this.assetService.getServerFilters(filter).subscribe((res)=> {
            this.serverFilter$.next(res.data)
            if (res.pageInfo) {
                this.pageInfo = res.pageInfo;
                /*if (res.pageInfo.currentPage === 1) {
                    this.clearLoadedAssets();
                }*/
            }
        })
    }
    loadNextPageAssets(filter:AssetFilter ) {
        if (filter.page === 1){
            this.clearLoadedAssets();
        }
        this.assetService.getAssets(filter).subscribe(
            result => {
               /* const assView: AssetView = {
                    assets: result.data,
                    //  pageInfo: result.pageInfo
                }
                this.result$.next(assView)*/
                /* if (result.pageInfo.currentPage === 1) {
                     this.clearLoadedAssets();
                 }*/
                this.loadedAssets$.next([...this.loadedAssets, ...result.data]);
            }
        );
    }
    set filterBlocked(filterBlocked:boolean) {
        this.filterBlocked$.next(filterBlocked);
    }

    get result() {
        return this.result$.value;
    }
    get serverFilter() {
        return this.serverFilter$.value;
    }

    get assetSelection() {
        return this.assetSelection$.value;
    }

    set assetSelection(assets:Asset[]) {
        this.assetSelection$.next(assets);
        // TODO we could update the assetCount here
        /*
        this.assetCount = {
            assetsSelected: assets.length,
            assetsTotal: this.result?.pageInfo.totalItems || 0,
            assetsVisible: this.result?.pageInfo.totalItems || 0
        }
         */
    }

    clearAssetSelection() {
        this.assetAction$.next(AssetAction.selectNone);
        this.assetSelection$.next([]);
    }

    clearFilter() {
      this.filter =  this.createDefaultAssetFilter();
    }
    createDefaultAssetFilter() : AssetFilter {
        // console.log('creating default filter now');
        return {
            page: 1,
            resultsPerPage: 300,
            order: OrderDirection.desc,
            orderBy: OrderBy.created,
            p_division: [],
            p_brand: [],
            collectionUuid: this.collection$?.value?.uuid,
            collectionSharedUuid: this.getCollectionSharedKey(),
            collectionPublicUuid: this.getCollectionPublicSlug(),
            p_asset_category: [],
            p_asset_type: [],
            p_channel: [],
            p_content: [],
            p_continent: [],
            p_language: [],
            p_product_type: [],
            p_product_category: [],
            p_season: [],
            p_sport: [],
            p_year: [],
            q: '',
            sku: ''
        };
    }

    private getCollectionSharedKey() {
        let col = this.readonlyCollection$?.value;
       // console.log('getCollectionKey', col);
        if (!!col && !!col.key) {
            return col.key;
        }
        return undefined;
    }

    private getCollectionPublicSlug() {

        let col = this.readonlyCollection$?.value;
       // console.log('getCollectionPublicSlug', col);
        if (!!col && !!col.slug) {
            return col.slug;
        }
        return undefined;
    }

    createInitialAssetCount() : AssetCount {
        return {
            assetsSelected: 0,
            assetsTotal: 0,
            assetsVisible: 0
        }
    }

    resetState() {
            this.loadedAssets$.next([]);
            this.filter$.next(this.createDefaultAssetFilter());
            this.serverFilter$.next([]);
            this.result$.next(null);
            this.assetCount$.next(this.createInitialAssetCount());
            this.assetAction$.next(AssetAction.none);
            this.filterBlocked$.next(true);
            this.assetSelection$.next([]);
            this.collection$.next(null);
            this.readonlyCollection$.next(null);
    }
}
